import prepareLongFileName from './prepareLongFileName'


/* NOTE: https://developer.mozilla.org/ru/docs/Web/API/Blob */
const downloadBlobFile = (file, type, name) => {
  if (!file) {
    throw new Error('file prop is not added to downloadBlobFile ')
  }

  if (!type) {
    throw new Error('type prop is not added to downloadBlobFile ')
  }

  const downloadAttributeSupport = 'download' in document.createElement('a')
  const isIE = !downloadAttributeSupport && (typeof window.navigator.msSaveBlob !== 'undefined')

  if (!isIE) {
    const prepareFile = (file, type) => {
      const responseBlob = new Blob([file], { type })

      return URL.createObjectURL(responseBlob)
    }

    let fakeLink = document.createElement('a')

    fakeLink.download = name
    fakeLink.href = prepareFile(file, type)

    fakeLink.click()
    fakeLink.remove()

    fakeLink = null
  } else {
    window.navigator.msSaveBlob(file, name)
  }
}

const downloadFileByUrl = ({ url, type, name }) => {
  if (!type) {
    throw new Error('Type is required property of downloadFileByLink arguments')
  }

  return new Promise((resolve, reject) => {
    window.spiral.ajax({
      url,
      method: 'GET',
      responseType: 'blob',
      processAnswer ({ request, response = null, isSuccess }) {
        const status = request.status

        if (isSuccess) {
          if (response) {
            downloadBlobFile(response, type, name)
          }

          return resolve({
            status: status,
            response: response,
            error: null,
          })
        }

        return reject({
          status: status,
          response: response,
          error: `ERROR: download status is ${status}`,
        })
      },
    })
  })
}

class MakeDisableLinkEl {
  constructor (anchor) {
    this.anchor = anchor

    this.anchorHref = anchor.getAttribute('href')
    this.anchorText = anchor.textContent
  }

  disable () {
    this.anchor.setAttribute('href', '')
    this.anchor.setAttribute('disabled', true)
    this.anchor.textContent = 'Downloading...'
  }

  enable () {
    this.anchor.setAttribute('href', this.anchorHref)
    this.anchor.textContent = this.anchorText
    this.anchor.removeAttribute('disabled')
  }

  element () {
    return this.anchor
  }
}

const handleAnchorDownload = ({ name, type, href, disabled }) => {
  const rejectError = (err) =>
    new Promise((resolve, reject) => reject(new Error(err)))

  if (!href) {
    console.error('Expected empty href attribute of element')

    return rejectError('Expected empty href attribute of element')
  }

  if (disabled) {
    return rejectError('Link is disable')
  }

  if (!name) {
    console.error('data-filename is required attribute for download link')

    return rejectError('data-filename is required attribute for download link')
  }

  if (!type) {
    console.error('data-mimetype is required attribute for download link')

    return rejectError('data-mimetype is required attribute for download link')
  }

  return downloadFileByUrl({ url: href, type, name: prepareLongFileName(name) })
    .then((result) => {
      return Promise.resolve(result)
    })
    .catch((error) => {
      console.error(error)

      return Promise.reject(error)
    })
}

export default handleAnchorDownload
export { MakeDisableLinkEl }
